// extracted by mini-css-extract-plugin
module.exports = {"container":"ScoreDetail_container__11Ev1","heading":"ScoreDetail_heading___V1uk"};